/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListDeviceTrendPointsRequest = {
  agentId: string;
};

/** @internal */
export const ListDeviceTrendPointsRequest$inboundSchema: z.ZodType<
  ListDeviceTrendPointsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type ListDeviceTrendPointsRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const ListDeviceTrendPointsRequest$outboundSchema: z.ZodType<
  ListDeviceTrendPointsRequest$Outbound,
  z.ZodTypeDef,
  ListDeviceTrendPointsRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function listDeviceTrendPointsRequestToJSON(
  listDeviceTrendPointsRequest: ListDeviceTrendPointsRequest,
): string {
  return JSON.stringify(
    ListDeviceTrendPointsRequest$outboundSchema.parse(
      listDeviceTrendPointsRequest,
    ),
  );
}
export function listDeviceTrendPointsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListDeviceTrendPointsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListDeviceTrendPointsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDeviceTrendPointsRequest' from JSON`,
  );
}
